import React from "react";
import { Autocomplete, TextField, InputAdornment, Box, Typography } from "@mui/material";
import { LocationOn } from "@mui/icons-material";

const LocationSelect = ({
  label = "Select Location *",
  value = [],
  locations = [],
  onChange,
  startIcon,
  error = false,
  helperText = ""
}) => {
  // Ensure locations is always an array and each item is a string
  const options = React.useMemo(() => {
    if (!Array.isArray(locations)) {
      console.log("Locations is not an array, converting...");
      return [];
    }
    const processedOptions = locations
      .map((loc) => {
        if (!loc) return null;
        if (typeof loc === "string") return loc.trim();
        if (typeof loc === "object" && loc.label) return loc.label.trim();
        return String(loc).trim();
      })
      .filter(Boolean);
    return processedOptions;
  }, [locations]);

  // Ensure value is always an array
  const selectedValue = React.useMemo(() => {
    if (!Array.isArray(value)) {
      console.log("Value is not an array, converting...");
      return [];
    }
    const processedValue = value
      .map((v) => {
        if (!v) return null;
        if (typeof v === "string") return v.trim();
        if (typeof v === "object" && v.label) return v.label.trim();
        return String(v).trim();
      })
      .filter(Boolean);
    return processedValue;
  }, [value]);

  return (
    <Autocomplete
      options={options}
      value={selectedValue}
      onChange={(event, newValue) => {
        onChange(newValue || []);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {startIcon || (
                  <InputAdornment position="start">
                    <LocationOn />
                  </InputAdornment>
                )}
                {params.InputProps.startAdornment}
              </>
            )
          }}
        />
      )}
      multiple
      size="small"
      renderOption={(props, option) => (
        <li {...props}>
          <Box display="flex" alignItems="center" gap={1}>
            <LocationOn sx={{ color: "text.secondary", fontSize: 20 }} />
            <Typography>{option}</Typography>
          </Box>
        </li>
      )}
      noOptionsText="No locations available"
      loadingText="Loading locations..."
    />
  );
};

export default LocationSelect;
